import React from 'react';
import { Icons, Icon, Tooltip, styled } from '@nextiva/next-ui-components';
import styles from './DeleteRoleIcon.scss';

interface style {
  disabled: boolean;
}
const StyledDeleteIcon = styled(Icon)<style>`
  width: 34px;
  &.MuiSvgIcon-root {
    fill: ${({ disabled }) => !disabled && '#da3444'};
    cursor: ${({ disabled }) => !disabled && 'pointer'};
  }
`;
const DeleteRoleIcon = ({ role, toggleDeleteModal }) => {
  let userDefined;
  let assignedProfilesCount;

  if (role) ({ userDefined, assignedProfilesCount } = role);

  const disabled = userDefined === false || assignedProfilesCount > 0; // we can only delete user_defined (non-default) roles with 0 assigned profiles
  let TooltipText;

  switch (true) {
    case userDefined === false:
      TooltipText = 'Roles that come standard cannot be deleted';
      break;
    case assignedProfilesCount > 0:
      TooltipText = 'This role has users assigned and cannot be deleted';
      break;
    default:
      TooltipText = 'Delete role';
  }

  return (
    <div className={styles.buttonWrapper}>
      <Tooltip title={TooltipText} placement="left">
        <div className={styles.tooltipHelper}>
          <button
            type="button"
            className={styles.svgButton}
            disabled={disabled}
            style={disabled ? { pointerEvents: 'none' } : {}}
          >
            <StyledDeleteIcon
              icon={Icons.delete}
              onClick={disabled === false ? toggleDeleteModal : null}
              onKeyDown={disabled === false ? toggleDeleteModal : null}
              data-testid="PlatformAdminUI-RolesAndPermissions-DeleteRoleIcon-DeleteButton"
              disabled={disabled}
            />
          </button>
        </div>
      </Tooltip>
    </div>
  );
};

export default DeleteRoleIcon;
